import { ReactNode } from 'react';

export { EditActions, EditButton } from '@hakimo-ui/shared/ui-base';

export const FIELD_LABEL_CLASS =
  'text-onlight-text-3 dark:text-ondark-text-2 text-xs font-medium uppercase tracking-wide';

export const PANEL_TITLE_CLASS =
  'text-onlight-text-1 dark:text-ondark-text-1 text-base font-semibold';

interface Props {
  title?: string;
  titleAdornment?: ReactNode;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function Panel({
  title,
  titleAdornment,
  action,
  className = '',
  children,
}: Props) {
  return (
    <div
      className={`dark:bg-ondark-bg-1 bg-onlight-bg-1 rounded-lg p-4 ${className}`}
    >
      {(title || action) && (
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            {title && <h2 className={PANEL_TITLE_CLASS}>{title}</h2>}
            {titleAdornment}
          </div>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export default Panel;
